import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const legalLinks = [
  { label: 'Terms of Service', path: '/terms' },
  { label: 'Privacy Policy', path: '/privacy' },
  // { label: 'Cookie Policy', path: '/cookies' },
  // { label: 'Refund Policy', path: '/refund' },
  // { label: 'AI Processing Consent', path: '/interview-consent' },
  { label: 'Beta Disclaimer', path: '/beta-disclaimer' },
];

const socialItems = [
  {
    label: 'LinkedIn',
    icon: 'Linkedin',
    href: 'https://www.linkedin.com/company/prepxai/',
    color: '#0A66C2',
  },
  {
    label: 'Instagram',
    icon: 'Instagram',
    href: 'https://www.instagram.com/prepxai/',
    color: '#E4405F',
  },
  {
    label: 'X',
    icon: 'Twitter',
    href: 'https://x.com/prepxai',
    color: '#1DA1F2',
  },
  {
    label: 'YouTube',
    icon: 'Youtube',
    href: 'https://www.youtube.com/@prepxai',
    color: '#FF0000',
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative mt-auto overflow-hidden border-t border-emerald-200/50 bg-white dark:border-[#1d1e26] dark:bg-[#08080a]">
      <div className="absolute bottom-0 left-0 right-0 z-0 h-[350px] bg-gradient-to-t from-emerald-200/40 to-transparent pointer-events-none dark:from-[#10E58F]/10" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 py-14">
        <div className="mb-16 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="mb-6 flex items-center gap-2">
              <span className="text-2xl font-black tracking-tight text-slate-900 dark:text-slate-100">
                prepx<span className="text-emerald-600">ai</span>
              </span>
            </div>

            <p className="max-w-sm text-[11px] font-medium leading-relaxed text-slate-700 dark:text-slate-400">
              AI interview preparation for realistic practice rounds, scorecards, and focused improvement.
            </p>

            <div className="mt-6 flex gap-3">
              <div className="mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-emerald-50 dark:bg-slate-800/40">
                <Icon name="Mail" size={12} className="text-emerald-600" />
              </div>
              <div>
                <h4 className="mb-1 text-[10px] font-black tracking-widest text-slate-900 dark:text-slate-100">
                  Email
                </h4>
                <a
                  href="mailto:contact@prepxai.in"
                  className="text-[11px] font-bold text-emerald-600 transition-colors hover:text-emerald-700"
                >
                  contact@prepxai.in
                </a>
              </div>
            </div>
          </div>

          {/* <div className="lg:col-span-4">
            <h4 className="mb-5 border-b border-emerald-50 pb-2 text-[10px] font-black tracking-widest text-emerald-600 dark:border-[#1d1e26]">
              Social Media
            </h4>
            <div className="flex flex-wrap gap-3">
              {socialItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  className="prepx-social-link group flex h-9 w-9 items-center justify-center rounded-full border border-emerald-50 bg-white text-slate-600 shadow-sm transition-all hover:-translate-y-0.5 hover:border-slate-200 hover:bg-white focus-visible:outline-none active:translate-y-0 dark:border-[#1d1e26] dark:bg-[#111216] dark:text-slate-400 dark:hover:border-[#2b2d35] dark:hover:bg-[#111216]"
                  style={{ '--social-color': item.color }}
                  title={item.label}
                  aria-label={item.label}
                >
                  <Icon name={item.icon} size={15} color={item.color} className="transition-transform group-hover:scale-110" />
                </a>
              ))}
            </div>
          </div> */}

          <div className="lg:col-span-4">
            <h4 className="mb-5 border-b border-emerald-50 pb-2 text-[10px] font-black tracking-widest text-emerald-600 dark:border-[#1d1e26]">
              Legal
            </h4>
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-1">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="block text-[11px] font-medium text-slate-700 transition-all hover:text-emerald-600 dark:text-slate-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-slate-100 pt-8 dark:border-[#1d1e26] sm:flex-row">
          <p className="text-[11px] font-medium text-slate-700 dark:text-slate-400">
            © {currentYear} prepxai. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
